import React from 'react';
import { NavLink } from 'react-router-dom';
import './BottomNav.css';

const BottomNav = ({ role }) => {
  const adminItems = [
    { path: '/admin/dashboard', label: 'Home', icon: '▣' },
    { path: '/admin/students', label: 'Students', icon: '👥' },
    { path: '/admin/batches', label: 'Batches', icon: '◫' },
    { path: '/admin/questions', label: 'Questions', icon: '❓' },
    { path: '/admin/tests', label: 'Tests', icon: '📋' },
  ];

  const studentItems = [
    { path: '/student/dashboard', label: 'Home', icon: '▣' },
    { path: '/student/tests', label: 'Tests', icon: '📋' },
    { path: '/student/mock', label: 'Mock', icon: '⚡' },
    { path: '/student/mistakes', label: 'Mistakes', icon: '❌' },
    { path: '/student/analytics', label: 'Stats', icon: '📊' },
  ];

  const items = role === 'admin' ? adminItems : studentItems;

  return (
    <nav className="bottom-nav">
      {items.map((item) => (
        <NavLink
          key={item.path}
          to={item.path}
          end={item.path === '/admin/dashboard' || item.path === '/student/dashboard'}
          className={({ isActive }) => `bottom-nav-item ${isActive ? 'active' : ''}`}
        >
          <span className="bottom-nav-icon">{item.icon}</span>
          <span className="bottom-nav-label">{item.label}</span>
        </NavLink>
      ))}
    </nav>
  );
};

export default BottomNav;
